import type { ReactNode } from "react"
import { useAppSelector } from "../../redux/hooks"
import { AnalyticsCard } from "../dashboard/Analitics"


export default function ProfileHeader() {
  const user = useAppSelector((state) => state.auth.user)
  return (
    <div className=" h-full">
      <div className="rounded-lg  h-full dark:bg-[#262626] border-transparent   bg-white shadow-md">
        {/* Banner */}
        <div
          style={{
            backgroundImage: "url(/bg-image.png)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top-left",
            backgroundSize: "cover"
          }}
          className="h-44 bg-[#3FBBA3] border-transparent rounded-lg w-full relative">
          <div className="absolute -bottom-12 left-6">
            <div className="rounded-full  bg-accent-500 flex items-center justify-center   w-20 h-20 lg:w-24 lg:h-24 overflow-hidden">
              <div className="flex justify-center items-center  w-full h-full rounded-full bg-gray-400 text-black hover:text-white hover:bg-gray-800">
                {
                  user?.profilePicturePath ? (
                    <img src={user.profilePicturePath} alt="User" className="w-full h-full rounded-full" />
                  ) : (
                    <span className={` rounded-full  text-5xl bg-accent-500  w-full h-full flex items-center justify-center text-white`}>
                      {user?.firstName?.[0] || "U"}
                    </span>
                  )
                }
              </div>
            </div>
          </div>
        </div>

        {/* Profile Info */}
        <div className="pt-14 p-2 md:px-6 pb-6">
          <h1 className="text-xl font-bold dark:text-white text-gray-900">{`${user?.firstName}`} {user?.middleName}</h1>

          {/* Stats */}
          <AnalyticsCard />
        </div>
      </div>
    </div>
  )
}

// Type definitions
interface ProfileStatProps {
  icon: ReactNode
  value: string
  label: string
  iconBgColor: string
}
